var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useEffect, useState } from 'react';
import { validateToken } from '@/api/authService';
import { deleteToken, setToken } from '@/utils';
import { useConfigContext } from './ConfigContext';
// Create the context with default values
var AuthContext = createContext(undefined);
var AuthProvider = function (_a) {
    var children = _a.children;
    // State for user, token, and authentication status
    var _b = useState(null), user = _b[0], setUser = _b[1];
    var _c = useState(false), isAuthenticated = _c[0], setIsAuthenticated = _c[1];
    var config = useConfigContext().config;
    // Load user data and token from localStorage when the app loads
    useEffect(function () {
        var getUserData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var userData;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, validateToken('', config === null || config === void 0 ? void 0 : config.validateTokenRoute)];
                    case 1:
                        userData = _b.sent();
                        if (userData.status === 'success' && ((_a = userData.data) === null || _a === void 0 ? void 0 : _a.is_valid)) {
                            setUser({
                                id: userData.data.user.id,
                                access_token: userData.data.user.access_token,
                                refresh_token: userData.data.user.refresh_token,
                                name: userData.data.user.name,
                                mobile: userData.data.user.mobile,
                            });
                            setIsAuthenticated(true);
                        }
                        else {
                            logout();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (!(user === null || user === void 0 ? void 0 : user.name))
            getUserData();
    }, [user === null || user === void 0 ? void 0 : user.name]);
    // Function to handle login
    var login = function (userData) {
        setUser(userData);
        setIsAuthenticated(true);
        setToken(userData.access_token);
        localStorage.setItem('refresh_token', userData === null || userData === void 0 ? void 0 : userData.refresh_token);
        setTimeout(function () {
            if (config === null || config === void 0 ? void 0 : config.shouldReloadOnLogin) {
                window.location.reload();
            }
        }, 300);
    };
    // Function to handle logout
    var logout = function () {
        setUser(null);
        setIsAuthenticated(false);
        deleteToken();
    };
    return (_jsx(AuthContext.Provider, { value: { user: user, isAuthenticated: isAuthenticated, login: login, logout: logout }, children: children }));
};
// Custom hook to use the AuthContext
var useAuth = function () {
    var context = React.useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
export { AuthProvider, useAuth };
